import { render, staticRenderFns } from "./ZhaoBiaoDaiLi.vue?vue&type=template&id=040abffa&scoped=true&"
import script from "./ZhaoBiaoDaiLi.vue?vue&type=script&lang=js&"
export * from "./ZhaoBiaoDaiLi.vue?vue&type=script&lang=js&"
import style0 from "./ZhaoBiaoDaiLi.vue?vue&type=style&index=0&id=040abffa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040abffa",
  null
  
)

export default component.exports